import { useEffect, useState } from 'react';
import useNotesApi from '../../api/useNotesApi';
import { Notes, defaultNotes } from '.';

export function useNotes(id: string) {
  const [notes, setNotes] = useState<Notes>(defaultNotes);

  const { getNotes } = useNotesApi();

  const fetchNotes = async () => {
    const result = await getNotes(id);
    setNotes((prev) => ({
      ...prev,
      ...result,
    }));
  };

  useEffect(() => {
    (async () => {
      await fetchNotes();
    })();
  }, [id]);

  return {
    notes,
  };
}
